module.exports = __webpack_public_path__ + "static/media/tick-success-sign.718fe325.gif";